<!-- Back from Stripe with the payment not confirmed yet: the checkout's layout (Figma 28520:21850),
     only the card changes. The page checks on its own; "Check again" comes after 30 seconds. -->
<div class="order-layout" *ngIf="job">
  <section class="order-main">
    <h1 class="flow-title">Your work. <span class="rf-nowrap">Ready to go.</span></h1>
    <p class="flow-subtitle"><span class="rf-name-with">“<span class="rf-name" [title]="job.name">{{ job.name }}</span>”</span> video pack.<br>${{ price }} for both finished videos&ensp;<ng-container *ngFor="let part of videoSpec; let last = last"><span class="rf-nowrap">{{ part }}{{ last ? '' : ' ·' }}</span>{{ last ? '' : ' ' }}</ng-container></p>

    <div class="order-devices">
      <app-render-still-devices *ngIf="job.preview as preview" [landscape]="preview.landscape" [portrait]="preview.portrait" [name]="job.name"></app-render-still-devices>
    </div>
  </section>

  <aside class="order-card order-card--confirming">
    <h2>{{ slow ? 'Still waiting for Stripe.' : 'Confirming your payment.' }}</h2>
    <p *ngIf="!slow" class="confirming-check" role="status"><span class="confirming-check__spin" aria-hidden="true"></span>Checking with Stripe</p>
    <p *ngIf="slow" class="order-card__lead" role="status">Payments usually confirm in seconds. If yours went through, the render starts by itself, and you won’t be charged twice.</p>

    <dl class="confirming-receipt">
      <div><dt><span class="confirming-receipt__name" [title]="job.name">{{ job.name }}</span><span class="confirming-receipt__what">&nbsp;· both videos</span></dt><dd>${{ price }}.00</dd></div>
      <div class="confirming-receipt__muted"><dt>One-time payment</dt><dd>USD</dd></div>
    </dl>

    <div *ngIf="error" class="rf-notice rf-notice--error confirming-error" role="alert">{{ error }}</div>

    <div class="confirming-foot">
      <ng-container *ngIf="!slow; else slowFoot">
        <p class="order-card__fine">This usually takes a few seconds. You can leave this page: the render starts once the payment is confirmed, and we email you when the videos are ready.</p>
        <button class="rf-text-link order-card__back" type="button" (click)="onBack()">Back to my preview</button>
      </ng-container>
      <ng-template #slowFoot>
        <button class="rf-button order-card__cta" type="button" [disabled]="checkingByHand" (click)="onCheckAgain()">{{ checkingByHand ? 'Checking…' : 'Check again' }}</button>
        <a class="rf-text-link confirming-support" [href]="supportHref">Contact support</a>
        <p class="order-card__fine">Checked {{ checks }} {{ checks === 1 ? 'time' : 'times' }}<ng-container *ngIf="lastCheck"> · last at {{ lastCheck | date: 'HH:mm' }}</ng-container></p>
      </ng-template>
    </div>
  </aside>
</div>
